import "./section5.scss";

import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { selectorLogos } from "src/storage";
import { FileFormat } from "src/types";
import { useResponsiveBp } from "src/utils/hook-functions/responsive-bp.hook";
export const useSection5 = () => {
  const { t } = useTranslation();

  const { isMobile } = useResponsiveBp();

  const logos = useRecoilValue(
    selectorLogos(isMobile ? FileFormat.MOBILE : FileFormat.DESKTOP)
  );

  const openLogo = (url?: string) => {
    if(!url) return;
  window.open(url, "_blank")
  }

  const contactUs = () => {
    window.open(`mailto:${t("footer.email")}`);
  };

  return {
    logos,

    t,
    contactUs,
    openLogo,
  };
};
